import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Controls.styles';
const Controls = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    return (React.createElement(S.Container, { ref: ref, className: props.className },
        props.renderPrev({
            disabled: !props.wrap && carousel.activeIndex === 0,
            type: 'button',
            onClick: (event) => {
                event.preventDefault();
                carousel.goToPrev(props.wrap);
            },
        }),
        props.renderNext({
            disabled: !props.wrap && carousel.activeIndex === carousel.maxIndex,
            type: 'button',
            onClick: (event) => {
                event.preventDefault();
                carousel.goToNext(props.wrap);
            },
        })));
});
Controls.displayName = 'Controls';
export default Controls;
